// Import this module on any other module like so:

export const NODE_ENV = process.env.NODE_ENV

export const IS_DEV = NODE_ENV === 'development'
export const IS_TEST = NODE_ENV === 'test'
export const IS_PROD = NODE_ENV === 'production'

export const PORT_APP = +process.env.PORT || 3000

export const URL_API = process.env.JAVA_URL_API

export const PHP_URL_API = process.env.PHP_URL_API

export const URL_APP = process.env.URL_APP

export const BASE_URL = process.env.BASE_URL

export const NVWA_URL = process.env.NVWA_URL

// TODO
export const TEMP_URL = process.env.TEMP_URL

export const SENV = process.env.SENV
export const IS_SPA = process.env.IS_SPA

export const REDIS_HOST = process.env.REDIS_HOST

export const REDIS_PORT = process.env.REDIS_PORT

export const REDIS_PASS = process.env.REDIS_PASS || ''

export const preFix = 'bb-$'

export default {
  IS_SPA,
  NODE_ENV,
  IS_DEV,
  IS_TEST,
  IS_PROD,
  PORT_APP,
  URL_API,
  PHP_URL_API,
  URL_APP,
  BASE_URL,
  NVWA_URL,
  SENV,
  preFix,
  TEMP_URL,
}
